const cache = new Map<string, Promise<boolean> | boolean>();

export function suspendWhileImageLoads(src: string): Promise<boolean> | boolean {
    if (typeof window === 'undefined') {
        /**
         * We don't want to suspend on the server, because that would mean `cache` growing until
         * we're out of memory and the app crashes.
         */
        return false;
    }
    let cacheValue = cache.get(src);
    if (!cacheValue) {
        const imagePromise = new Promise<boolean>(resolve => {
            function stopSuspense(): void {
                cache.set(src, true);
                resolve(true);
            }
            try {
                const img = new Image();
                img.onload = () => {
                    if (img.decode) {
                        img.decode().then(stopSuspense).catch(stopSuspense);
                    } else {
                        stopSuspense();
                    }
                };
                img.onerror = stopSuspense;
                img.src = src;
            } catch (err) {
                stopSuspense();
            }
        });
        cache.set(src, imagePromise);
        cacheValue = imagePromise;
    }
    if (cacheValue instanceof Promise) {
        /**
         * Trigger suspense.
         */
        throw cacheValue;
    }
    return cacheValue;
}
